var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal-wrapper--transition" } }, [
    _vm.opened
      ? _c("div", { staticClass: "modal-wrapper", class: _vm.wrapperClasses }, [
          _c("div", { staticClass: "modal-wrapper__bg" }),
          _c(
            "div",
            { staticClass: "modal-wrapper__window" },
            [
              _vm._t("modalWindow", [
                _c(
                  "div",
                  { staticClass: "modal is-opened", class: _vm.modalClasses },
                  [
                    _vm.dismissible
                      ? _c(
                          "a",
                          {
                            staticClass: "modal__close",
                            attrs: { href: "" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.dismiss()
                              }
                            }
                          },
                          [_vm._v("×")]
                        )
                      : _vm._e(),
                    _c("div", { staticClass: "modal__inner" }, [
                      _vm.title || _vm.$slots.header
                        ? _c(
                            "div",
                            { staticClass: "modal__header" },
                            [
                              _vm._t("header", [
                                _c("div", {
                                  staticClass: "modal__title",
                                  domProps: { innerHTML: _vm._s(_vm.title) }
                                })
                              ])
                            ],
                            2
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "modal__content" },
                        [_vm._t("default")],
                        2
                      ),
                      _vm.$slots.footer
                        ? _c(
                            "div",
                            { staticClass: "modal__footer" },
                            [_vm._t("footer")],
                            2
                          )
                        : _vm._e()
                    ])
                  ]
                )
              ])
            ],
            2
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d3946662", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3946662","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/shared/components/modal/modal.vue
// module id = 174
// module chunks = 4